export const topicTags = [
  { id: 'all', name: '全部', count: 128, tone: 'cyan' },
  { id: 'hot', name: '热门', count: 36, tone: 'gold' },
  { id: 'notice', name: '公告', count: 8, tone: 'red' },
  { id: 'fanwork', name: '同人创作', count: 24, tone: 'green' },
  { id: 'request', name: '求漫互助', count: 41, tone: 'blue' },
  { id: 'review', name: '读后感', count: 19, tone: 'purple' }
]

export const pinned = [
  {
    id: 1,
    title: '社区发帖规范与付费内容讨论说明',
    summary: '讨论剧情、角色和阅读体验时请避免剧透标题，付费章节请使用模糊描述。'
  },
  {
    id: 2,
    title: '本周推荐话题：你最想看到哪类漫画上新',
    summary: '古风、悬疑、都市、奇幻都可以聊，优质建议会进入运营看板。'
  }
]

export const communityPosts = [
  {
    id: 101,
    topic: 'hot',
    title: '最近的会员章节节奏变快了，大家更喜欢周更还是集中更新？',
    author: '夜读观察员',
    role: 'VIP会员',
    time: '12分钟前',
    digest: '我个人更喜欢每周固定时间更新，追读感更强，也方便在评论区一起讨论伏笔。',
    tags: ['更新节奏', '会员章节'],
    likes: 268,
    comments: 42,
    views: '1.8k',
    pinned: true,
    heated: true
  },
  {
    id: 102,
    topic: 'fanwork',
    title: '画了一张主角团集合壁纸，想听听配色建议',
    author: '铅笔还没削',
    role: '创作者',
    time: '38分钟前',
    digest: '目前用了冷蓝和金色光效，但感觉人物边缘还不够突出，大家觉得背景需要压暗吗？',
    tags: ['同人图', '壁纸'],
    likes: 184,
    comments: 27,
    views: '980',
    pinned: false,
    heated: true
  },
  {
    id: 103,
    topic: 'request',
    title: '求推荐类似悬疑反转、每章都有线索的漫画',
    author: '第七页书签',
    role: '普通用户',
    time: '1小时前',
    digest: '希望不是单纯吓人，更偏推理和人物关系。最好已经完结，方便一口气看完。',
    tags: ['求漫', '悬疑'],
    likes: 93,
    comments: 31,
    views: '742',
    pinned: false,
    heated: false
  },
  {
    id: 104,
    topic: 'notice',
    title: '端午活动积分兑换入口将于本周五关闭',
    author: '道晗运营',
    role: '官方',
    time: '2小时前',
    digest: '请还没有兑换头像框和阅读券的用户尽快处理，活动结束后积分会保留到下一期社区任务。',
    tags: ['活动公告', '积分'],
    likes: 156,
    comments: 18,
    views: '2.4k',
    pinned: true,
    heated: false
  },
  {
    id: 105,
    topic: 'review',
    title: '聊聊新上架作品第一卷的人物动机',
    author: '慢速翻页',
    role: '书评人',
    time: '3小时前',
    digest: '第一卷看完后觉得反派不是纯粹脸谱化，他的目标和主角其实在某个层面是重叠的。',
    tags: ['读后感', '剧情分析'],
    likes: 121,
    comments: 16,
    views: '688',
    pinned: false,
    heated: false
  },
  {
    id: 106,
    topic: 'hot',
    title: '你们会因为评论区讨论去补一部老漫画吗？',
    author: '补档进行中',
    role: 'VIP会员',
    time: '昨天',
    digest: '最近看大家讨论经典老作，反而比推荐榜更容易被种草。想知道大家一般怎么筛选。',
    tags: ['补番补漫', '社区推荐'],
    likes: 207,
    comments: 55,
    views: '3.1k',
    pinned: false,
    heated: true
  }
]

export const activeUsers = [
  { name: '夜读观察员', score: 982, badge: '周榜第一' },
  { name: '铅笔还没削', score: 814, badge: '创作达人' },
  { name: '第七页书签', score: 766, badge: '互助达人' },
  { name: '慢速翻页', score: 651, badge: '长评作者' }
]

export const communityStats = [
  { label: '今日发帖', value: '86' },
  { label: '活跃讨论', value: '312' },
  { label: '同人作品', value: '24' }
]
